<template>
    <div>
        <div>
            <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加外链推荐' }" v-has="'btn_add'" > 添加外链推荐</a-button>
            <a-button class="top_btn" type="primary" @click="()=>{visibleImport=true}" v-has="'btn_import'" > 批量导入</a-button>
            <a-popconfirm
                    title="此操作将永久删除, 是否继续?"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm=" editLanguage('','5') "
                    @cancel="()=>{}"
                    :disabled="!hasSelected"
            >
                <a-button  type="primary" :disabled="!hasSelected" :loading="loading"  v-has="'btn_delete'">删除</a-button>

            </a-popconfirm>
            <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template>
      </span>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改外链推荐'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm([record.id])"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
              <NewForm :visible="visibleForm" :title="titleForm" :editId="editId"  @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList(pagination.current)}  "/>

        <a-modal
                title="批量导入外链"
                :visible="visibleImport"
                @cancel="()=>{this.fileList=[ ];this.visibleImport=false;this.content='';this.msgImport=''}"
                :maskClosable="false"
        >
            <template slot="footer">
                <a-button key="submit" type="primary"  @click="()=>{this.fileList=[ ];this.visibleImport=false;this.content='';this.msgImport='',this.getList()}">
                    确定
                </a-button>
            </template>
            <p>1.下载模板   <a-button type="link" icon="download" shape="round" @click="download" >Download</a-button></p>
            <p>2.上传文件  <a-upload
                    :action="this.$store.state.urlImport"
                    :file-list="fileList"
                    :headers="headers"
                    :remove="()=>{return false}"
                    @change="handleChange"
            >
                <a-button type="link" icon="upload" shape="round" v-if="fileList.length < 1">Upload</a-button>
            </a-upload>   </p>
            <p v-html='content'> </p>
            <p v-html='msgImport'></p>
        </a-modal>
    </div>

</template>

<script>
    import API from "./api";
    import NewForm from "./components/newForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "链接",
            dataIndex: "link",
            width: "15%",
            ellipsis: true,
            key: "link"
        },
        {
            title: "行业",
            dataIndex: "industry_name",
            ellipsis: true,
            key: "industry_name"
        },
        {
            title: "DA",
            dataIndex: "da",
            ellipsis: true,
            key: "da"
        },
        {
            title: "是否传递权重",
            dataIndex: "follow_name",
            ellipsis: true,
            key: "follow_name",
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            ellipsis: true,
            key: "update_time"
        },
        {
            title: "状态",
            key: "status",
            width: "10%",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'index',
        data() {
            return {
                content:'',
                msgImport:"",
                action:`${this.$store.state.urlExper}/detect/AExternalLink/import`,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                fileList: [ ],
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                selectedRowKeys: [], // Check here to configure the default column
                visibleForm: false,
                visibleImport:false,
                titleForm: "",
                loading: true,
                editId: null,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/ExternalRecommendation"; //设置左侧导航2-2 active
        },
        components: {NewForm},
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
            handleOk(){
                this.visibleImport=false
            },
            download(){
                window.open(`${this.$store.state.urlExper}/detect/AExternalLink/download `)
                API.service.DOWNLOAD().then(res => {

                })
            } ,
            handleChange(info,index ) {
                let {fileList} = info;
                const status = info.file.status;
                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    this.content=""
                    this.msgImport=""
                    if(fileList[0].response.data.content!=""){
                        this.fileList=[]
                        this.content=fileList[0].response.data.content
                        this.msgImport=fileList[0].response.data.msg
                    }else{
                        this.content=fileList[0].response.data.content
                        this.msgImport=fileList[0].response.data.msg
                    }
                }
                //重新设置state
                // this.setState( {fileList});
            },
            getList(page) {
                this.loading=true
                API.service.GET_LIST(page||1).then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList(this.pagination.current)
                    }
                })
            },
            confirm(id) {
                removeById(API.service.DELE,id).then(res => {
                    if (res == true) {
                        this.getList()
                        this.selectedRowKeys=[]
                    }
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            editLanguage(name, type) {
                if (type == '5') {
                    this.confirm(this.selectedRowKeys)
                }
                if(type==''){
                    changStatus(API.service.CHANG_STATUS, [Json]).then(res => {
                        if (res == true) {
                            this.getList()
                        }
                    })
                }
            }
        },
        mounted() {
            this.getList()
        }

    }
</script>
<style>
    .ant-upload-list-item-card-actions{display: none!important;}
</style>
